export const MAX_CONTAINER_WIDTH = '1240px';
export const MAIN_CONTENT_MARGIN_TOP = '70px';

export const BUTTON_HEIGHT = 54;

const HEADER_TOP_PADDING = 16;

export const HEADER_HEIGHT = BUTTON_HEIGHT + HEADER_TOP_PADDING;

export const USER_PROFILE_AVATAR_SIZE = 45;

// Web
export const OUTER_CIRCLE_SIZE = 760;
export const CIRCLE_SVG_SIZE = 600;
export const CIRCLE_WIDTH = 2.3;
export const CIRCLES_SVG_DATA = [
  { radius: 130, opacity: 0.8 },
  { radius: 170, opacity: 0.6 },
  { radius: 210, opacity: 0.4 },
  { radius: 250, opacity: 0.2 },
];

// Mobile

export const OUTER_CIRCLE_SIZE_MOBILE = 440;
export const CIRCLE_SVG_SIZE_MOBILE = 450;
export const CIRCLE_WIDTH_MOBILE = 2;
export const CIRCLES_SVG_DATA_MOBILE = [
  { radius: 85, opacity: 0.8 },
  { radius: 130, opacity: 0.6 },
  { radius: 175, opacity: 0.4 },
  { radius: 220, opacity: 0.2 },
];

export const FORM_FIELD_WIDTH = '300px';
export const CENTERED_FORM_WIDTH = '620px';

export const OBSERVATIONS_NOTES_WIDTH = '500px';

export const TIMELINE_ICON_DIMENSION = 50;
export const TIMELINE_DATE_TEXT_DIMENSION = 55;
export const TIMELINE_ITEMS_GAP = 20;

export const PROFILE_DROPDOWN_WIDTH_ADMIN = '180px';
export const PROFILE_DROPDOWN_WIDTH_EMPLOYEE = '150px';

export const MAX_SCREENER_SLIDE_WIDTH = '620px';

export const DOMAIN_ICON_SIZE = '72px';

export const SUPPORT_TEAM_CARD_WIDTH = '380px';
export const SUPPORT_TEAM_CARD_HEIGHT = '480px';

export const DASHBOARD_RIGHT_PANEL_WIDTH_PX = '400px';

export const OVERVIEW_RIGHT_SIDE_PANEL_HEIGHT = 600;

export const CARD_ITEM_WIDTH = '690px';
